import React, { useContext } from 'react';

import { AuthContext } from './contexts/AuthContext';
import Forbidden from './pages/Forbidden';

const ProtectedRoute = ({ module, action = 'read', children }) => {
  const { shouldHideModule } = useContext(AuthContext);

  const hide = shouldHideModule(module, action);

  if (hide) {
    return <Forbidden />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
